import { render, staticRenderFns } from "./ImportTokenAlert.vue?vue&type=template&id=52b8ba9e&"
import script from "./ImportTokenAlert.vue?vue&type=script&lang=js&"
export * from "./ImportTokenAlert.vue?vue&type=script&lang=js&"
import style0 from "./ImportTokenAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports